export const FORM_PAGE_READY_EVENT = 'designer:form-page-ready'

const FORM_PAGE_READY_STATE_KEY = '__designerFormPageReady'

const getReadyState = () => {
  if (!window[FORM_PAGE_READY_STATE_KEY]) {
    window[FORM_PAGE_READY_STATE_KEY] = {}
  }

  return window[FORM_PAGE_READY_STATE_KEY]
}

export const getFormPageReadyKey = (location = {}) => {
  return `${location.pathname || ''}:${location.search || ''}`
}

export const getFormPageReady = (readyKey) => {
  return getReadyState()[readyKey] || {}
}

export const setFormPageReady = ({
  readyKey,
  isReady = false,
  isLoading = false,
  source = '',
}) => {
  if (!readyKey) return

  let readyState = getReadyState()
  let readyData = {
    readyKey,
    isReady,
    isLoading,
    source,
  }

  readyState[readyKey] = readyData
  window.dispatchEvent(
    new CustomEvent(FORM_PAGE_READY_EVENT, { detail: readyData }),
  )
}
